import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
  Props.
*/

interface BusinessHoursDialogCtaProps {
  onConfirm: Handler;
  onCancel: Handler;
  confirmDisabled: boolean;
}

/*
  Style.
*/

const Cta = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const CancelButton = styled(Button)`
  margin-right: 10px;
`;

/*
  Component.
*/

export const BusinessHoursDialogCta = ({
  onCancel,
  onConfirm,
  confirmDisabled,
}: BusinessHoursDialogCtaProps) => (
  <Cta>
    <CancelButton
      onClick={onCancel}
      variant={ButtonVariantsEnum.SECONDARY}
      size={VisualSizesEnum.MEDIUM}
      interactionId="cancel"
    >
      <Trans id="cancel">Cancel</Trans>
    </CancelButton>
    <Button
      onClick={onConfirm}
      variant={ButtonVariantsEnum.PRIMARY}
      size={VisualSizesEnum.MEDIUM}
      isDisabled={confirmDisabled}
      interactionId="save"
    >
      <Trans id="save">Save</Trans>
    </Button>
  </Cta>
);
